import React from 'react';

const NewSalesLawIcon = ({ width = '24', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <defs>
      <style>{`.salesLawIconClass{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:0.65px;}`}</style>
    </defs>
    <g id="Bold_60" transform="translate(0.387 0.375)">
      <path
        id="Shape_190"
        className="salesLawIconClass"
        d="M9.966,602.159a.689.689,0,0,0-.915,0l-4.936,4.389a.344.344,0,0,0,.229.6H5.722a.344.344,0,0,1,.344.344v3.443a.689.689,0,0,0,.689.689H8.132a.344.344,0,0,0,.344-.344V609.56a1.033,1.033,0,0,1,2.066,0v1.722a.344.344,0,0,0,.344.344h1.377a.689.689,0,0,0,.689-.689v-3.443a.344.344,0,0,1,.344-.344h1.377a.344.344,0,0,0,.229-.6Z"
        transform="translate(-1.246 -595.122)"
        stroke="#333"
        strokeWidth="0.5"
      />
      <path
        id="Shape_191"
        className="salesLawIconClass"
        d="M21.544,597.953a.56.56,0,0,0-.344-1h-.658a.345.345,0,0,1-.308-.19l-.477-.954a.581.581,0,0,0-1,0l-.477.954a.345.345,0,0,1-.3.192h-.6a.56.56,0,0,0-.317,1.021l.539.372a.344.344,0,0,1,.129.4l-.275.782a.559.559,0,0,0,.863.634l.742-.556a.345.345,0,0,1,.413,0l.805.6a.56.56,0,0,0,.876-.594l-.244-.9a.344.344,0,0,1,.123-.364Z"
        transform="translate(-5.235 -593.109)"
        fill="#fff"
        stroke="#333"
        strokeWidth="0.5"
      />
      <path
        id="Shape_192"
        className="salesLawIconClass"
        d="M4.117,600.161a.563.563,0,0,0,.2-.637l-.275-.781a.344.344,0,0,1,.129-.4l.541-.373a.559.559,0,0,0-.317-1.021H3.788a.345.345,0,0,1-.308-.19L3,595.807a.581.581,0,0,0-1,0l-.477.954a.345.345,0,0,1-.308.19H.559a.56.56,0,0,0-.34,1l.518.4a.344.344,0,0,1,.123.364l-.244.9a.559.559,0,0,0,.876.592l.806-.6a.345.345,0,0,1,.413,0l.742.556A.559.559,0,0,0,4.117,600.161Z"
        transform="translate(-0.001 -593.11)"
        fill="#fff"
        stroke="#333"
        strokeWidth="0.5"
      />
      <path
        id="Shape_193"
        className="salesLawIconClass"
        d="M8.5,595.788a.344.344,0,0,1,.119.42l-.438,1a.689.689,0,0,0,.174.8.7.7,0,0,0,.826.091l1.263-.711a.343.343,0,0,1,.337,0l1.262.711a.7.7,0,0,0,.826-.091.689.689,0,0,0,.174-.8l-.441-1.005a.344.344,0,0,1,.118-.419l.777-.545a.693.693,0,0,0,.164-.758.679.679,0,0,0-.643-.421h-.9a.344.344,0,0,1-.322-.222l-.54-1.423c0-.012-.009-.023-.014-.034a.727.727,0,0,0-1.28.033l-.54,1.424a.344.344,0,0,1-.322.222H8.2a.679.679,0,0,0-.643.42.712.712,0,0,0,.207.8Z"
        transform="translate(-2.338 -592.02)"
        fill="#fff"
        stroke="#333"
        strokeWidth="0.5"
      />
    </g>
  </svg>
);
export default NewSalesLawIcon;
